module.exports = __webpack_public_path__ + "jab/media/dashboard.c6425961.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/dashboard.svg
// module id = 1472
// module chunks = 0